import React, { useState, useEffect } from "react";
import { FaArrowRight, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./Hero.css";

const Hero = () => {
  // Array of images for the carousel
  const heroImages = [
    {
      src: "/assets/Events/Radiance12025.jpg",
      alt: "Radaiance Event - Annual Awards Ceremony and AGM",
    },
    {
      src: "/assets/Events/Nurturenook12025.jpg",
      alt: "Nurturenook Event - Community Engagement",
    },
    {
      src: "/assets/Events/Futuro12025.jpg",
      alt: "Futuro Event - Innovation Showcase",
    },
    {
      src: "/assets/Events/Enginuity12025.jpg",
      alt: "Enginuity Event",
    },
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Auto-advance carousel every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === heroImages.length - 1 ? 0 : prevIndex + 1,
      );
    }, 4000);

    return () => clearInterval(interval);
  }, [heroImages.length]);

  const nextImage = () => {
    setCurrentImageIndex(
      currentImageIndex === heroImages.length - 1 ? 0 : currentImageIndex + 1,
    );
  };

  const prevImage = () => {
    setCurrentImageIndex(
      currentImageIndex === 0 ? heroImages.length - 1 : currentImageIndex - 1,
    );
  };
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-background">
        <div className="hero-overlay"></div>
        <img
          src="/api/placeholder/1920/1080"
          alt="IEEE WIE Background"
          className="hero-bg-image"
        />
      </div>

      <div className="container">
        <div className="hero-content">
          <div className="hero-text animate-fade-in-left">
            <div className="hero-badge">
              <span>Empowering Women in Engineering</span>
            </div>
            <h1 className="hero-title">
              IEEE Women in Engineering
              <span className="gradient-text">University of Moratuwa</span>
            </h1>
            <p className="hero-description">
              We are a dynamic community of engineers and technologists
              dedicated to inspiring, engaging, and advancing women in
              engineering and technology. Join us in creating innovative
              solutions and breaking barriers in STEM fields.
            </p>
            <div className="hero-buttons">
              <button
                className="btn btn-primary"
                onClick={() => scrollToSection("projects")}
              >
                Explore Projects <FaArrowRight />
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => scrollToSection("team")}
              >
                Meet Our Team <FaArrowRight />
              </button>
            </div>
          </div>

          <div className="hero-image animate-fade-in-right">
            <div className="image-container">
              <div className="image-carousel">
                <button
                  className="carousel-btn carousel-btn-prev"
                  onClick={prevImage}
                >
                  <FaChevronLeft />
                </button>
                <img
                  src={heroImages[currentImageIndex].src}
                  alt={heroImages[currentImageIndex].alt}
                  className="main-image"
                />
                <button
                  className="carousel-btn carousel-btn-next"
                  onClick={nextImage}
                >
                  <FaChevronRight />
                </button>
                <div className="carousel-indicators">
                  {heroImages.map((_, index) => (
                    <button
                      key={index}
                      className={`indicator ${index === currentImageIndex ? "active" : ""}`}
                      onClick={() => setCurrentImageIndex(index)}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
